import React from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { TableCell, TableRow, Checkbox } from '@mui/material';
import { ThemedTypography } from 'components/common/CommonStyles';
import PropTypes from 'prop-types';

export const FinancedOffersAssetInformationItemComponent = ({
  assetAdditionalInformation,
  offerId,
  offerSiteId,
  selectAssetsForContractGeneration,
  selected,
  assetId,
  canGenerateContract
}) => {
  return (
    <TableRow key={assetAdditionalInformation.assetInformationId}>
      <TableCell>
        <Checkbox
          checked={selected}
          onChange={selectAssetsForContractGeneration(offerId, offerSiteId, assetId, assetAdditionalInformation.assetInformationId)}
          disabled={assetAdditionalInformation.contractNumber ? true : canGenerateContract === true ? false : true}
        />
      </TableCell>
      <TableCell>
        <ThemedTypography color='info'>{assetAdditionalInformation.orderNo}</ThemedTypography>
      </TableCell>
      <TableCell>
        <ThemedTypography color='info'>{assetAdditionalInformation.chassisNumber}</ThemedTypography>
      </TableCell>
      <TableCell>
        <ThemedTypography color='info'>{assetAdditionalInformation.contractNumber}</ThemedTypography>
      </TableCell>
    </TableRow>
  );
};

FinancedOffersAssetInformationItemComponent.propTypes = {
  assetAdditionalInformation: PropTypes.object.isRequired,
  offerId: PropTypes.number.isRequired,
  offerSiteId: PropTypes.number.isRequired,
  assetId: PropTypes.number.isRequired,
  selectAssetsForContractGeneration: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  canGenerateContract: PropTypes.bool.isRequired
};

export default compose(withTranslation())(FinancedOffersAssetInformationItemComponent);
